import * as React from "react";
import ActivityItem from "./ActivityItem";
import {CallRow} from "../../graphql/subscription/callRow";

interface ActivityListProps {
    status: CallRow[];
}

export default function ActivityList({status}: ActivityListProps) {
    if (!status.length) {
        return (
            <div className="px-6 py-12 text-center text-sm italic text-muted-foreground">
                No current active calls.
            </div>
        );
    }

    return (
        <ul className="divide-y divide-border/60">
            {status.map((s) => <ActivityItem key={s.channelId} status={s} />)}
        </ul>
    );
}
